import request from "@/config/utils/request";

// 编辑
export function postEditContractMaterials(data) {
  return request({
    url: "/apis/demo/contractmaterials/editContractMaterials",
    method: "POST",
    data
  });
}
// 添加
export function postAddContractMaterials(data) {
  return request({
    url: "/apis/demo/contractmaterials/saveContractMaterials",
    method: "POST",
    data
  });
}
// 删除
export function postDeleteContractMaterials(data) {
  return request({
    url: "/apis/demo/contractmaterials/removeContractMaterials", // 后端接口
    method: "post",
    data
  });
}
// 详情
export function postGetDetail(data) {
  return request({
    url: "/apis/demo/contractmaterials/getContractMaterialsById", // 后端接口
    method: "POST",
    data
  });
}
// 批量查询
export function postGetList(data) {
  return request({
    url: "/apis/demo/contractmaterials/listContractMaterialsPage",
    method: "POST",
    data
  });
}
